module.exports = __webpack_public_path__ + "static/media/tip-inactive.af9d43da.svg";